// extracted by mini-css-extract-plugin
var _1 = "MetaList-module__metaList--RyDQT";
export { _1 as "metaList" }
